module.exports = __webpack_public_path__ + "img/icon-mail-1.30a4464e.svg";